<template>
  <div id="app">
    
    <router-view/>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loggedIn: false
    }
  },
  created () {
    this.$cognitoAuth.isAuthenticated((err, loggedIn) => {
      if (err) {
        console.error("App: Couldn't get the session:", err, err.stack)
        return
      }
      this.loggedIn = loggedIn
    })
    this.$cognitoAuth.onChange = loggedIn => {
      this.loggedIn = loggedIn
    }
  }
}
</script>

<style>
html, body, h1, h2, h3, h4, h5, p, ul, li {
  font-family: 'Roboto', sans-serif;
}
.btn-floating.orange {
  background-color: #fbb040!important;
}
.blue-nav {
  background-color: #27aae1!important;
}
/* Toolbar navigation */
nav {
  margin-bottom: 4em;
}
nav span.nav-title {
  font-size: 20px;
  
  padding: 0px 50px;
}
.tabs .tab {
  font-size: 13px;
  text-transform: none;
}
nav {
  padding-left: 15px;
}

/* Sidebar */
body.has-sidebar {
  padding-left: 100px;
}

.category-header {
  color: #27282A;
  font-size: 18pt;
  font-weight: 400;
  border-bottom: 1px solid rgba(0,0,0,0.42);
  padding-left: 0px;
  padding-bottom: 10px;
}
/* Lists */
.collection-header {
  color: #7e7e7e;
  font-size: 14px;
  border-bottom: 1px solid rgba(0,0,0,0.42);
  padding-left: 30px;
  padding-bottom: 14px;
}
.collection {
  border: none;
  
  font-size: 16px;
}
.collection li.collection-item {
  border: none;
}
.collection li:hover {
  background-color: #f2f2f2;
}
.collection .author, .collection a, .collection .description {
  color: #7e7e7e;
  font-size: 14px;
}

.dropdown-content li > a {
  font-size: 15px !important;
  color: #2f2f2f !important;
}
.dropdown-content li > span{
  color: #2f2f2f !important;
}
.dropdown-content li > a > i {
  color: #7e7e7e;
}

.passwordStrength {
  text-align: right;
  display: inline-block;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-right: 10px;
  padding-left: 10px;
  color: white;
  border-radius: 3px;
}
.weak {
  background-color: red;
}
.medium {
  background-color: orange;
}
.strong {
  background-color: green;
}

.tabs, .tabs a {
  font-size: 13px!important;
}
.tabs.tabs-transparent .indicator, .tabs .indicator {
  background-color: #fbb040!important;
}
.tabs .tab a:focus, .tabs .tab a:focus.active {
  background-color: #40abe1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue